// extracted by mini-css-extract-plugin
var _1 = "SubscriptionCancelled_button__vX2K3";
var _2 = "SubscriptionCancelled_container__oMHej";
var _3 = "SubscriptionCancelled_endDateDisclaimer__gQz3J";
var _4 = "SubscriptionCancelled_info__gJeRO";
var _5 = "SubscriptionCancelled_title__sVDy-";
export { _1 as "button", _2 as "container", _3 as "endDateDisclaimer", _4 as "info", _5 as "title" }
